import {mapMutations, mapActions, mapGetters} from "vuex";
import slider from '@/modules/home/section/news/slider/index.vue'
import card from '@/modules/home/section/news/card/index.vue'

export default {
    name: "news",
    components: {

        card,
        slider
    },
    props: {
        item: {
            type: String,
            default: () => {
            }
        },
    },
    data() {
        return {}
    },
    created() {

    },
    computed: {
        ...mapGetters({

        })
    },
    methods: {
        ...mapMutations({}),
        ...mapActions({

        })
    }
}
